module.exports = __webpack_public_path__ + "fondoTemporal.5da0c0c28cf84532d540.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/assets/img/fondoTemporal.jpg
// module id = ../../../../../src/assets/img/fondoTemporal.jpg
// module chunks = styles